var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodmeshLogoRectangleTagline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 110",
    style: {
      enableBackground: "new 0 0 320 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#19493A;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1028,
    y1: 1056.4395,
    x2: 90.6171,
    y2: 970.678,
    gradientTransform: "matrix(1 0 0 1 0 -968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    style: {
      stopColor: "#91C248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3314,
    style: {
      stopColor: "#5FA844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    style: {
      stopColor: "#379341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7201,
    style: {
      stopColor: "#1A843F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#097B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03783D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.1,60.1h5.1v-31H4.1v-6.8h33V35h-7.3v-6H16.9v12.8h13.2v6.6H16.9v11.7h6v6.8H4.1V60.1z M33.6,53.7 c0-7.3,5.5-13.9,14.3-13.9c8.9,0,14.3,6.5,14.3,13.9c0,7.3-5.5,13.9-14.3,13.9C39,67.6,33.6,61.1,33.6,53.7z M55.3,53.7 c0-4.9-3-8.3-7.4-8.3s-7.4,3.4-7.4,8.3s3,8.3,7.4,8.3S55.3,58.6,55.3,53.7z M65.7,53.7c0-7.3,5.5-13.9,14.3-13.9 c8.9,0,14.3,6.5,14.3,13.9c0,7.3-5.5,13.9-14.3,13.9C71.1,67.6,65.7,61.1,65.7,53.7z M87.4,53.7c0-4.9-3-8.3-7.4-8.3 s-7.4,3.3-7.4,8.3s3,8.3,7.4,8.3S87.4,58.6,87.4,53.7z M97.7,53.8c0-7.7,5.7-14,12.8-14c3.4,0,6,1.3,7.4,2.5V27.9h-4v-5.6h10.7 v39.3h4v5.5H118v-2.9c-2,1.9-4.5,3.4-7.9,3.4C103,67.6,97.7,61.8,97.7,53.8z M118.1,59.1V47.6c-1.8-1.3-3.8-2.1-6.4-2.1 c-3.7,0-7.1,2.8-7.1,8.2c0,5.2,3.2,8.1,7.1,8.1C114.2,61.8,116.2,60.6,118.1,59.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,26.2c0-2.2,1.8-3.9,3.9-3.9h0.8c1.8,0,2.8,0.9,3.6,2.1l13.5,21.1l13.7-21.2c0.8-1.4,2-2.1,3.5-2.1h0.8 c2.2,0,3.9,1.8,3.9,3.9v37.2c0,2.2-1.8,3.9-3.9,3.9c-2.1,0-3.9-1.8-3.9-3.9V36.8L160,53.1c-0.8,1.3-1.9,2.1-3.3,2.1 c-1.4,0-2.4-0.8-3.2-2.1l-10.8-16.2v26.7c0,2.2-1.8,3.8-3.9,3.8s-3.8-1.7-3.8-3.8L135,26.2L135,26.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.7,67.7c-7.9,0-14-5.8-14-14.2v-0.1c0-7.8,5.5-14.2,13.3-14.2c8.7,0,12.9,7.1,12.9,13.4 c0,1.8-1.4,3-2.9,3h-17.1c0.7,4.4,3.8,6.9,7.8,6.9c2.6,0,4.7-0.9,6.5-2.3c0.5-0.4,0.9-0.6,1.6-0.6c1.4,0,2.4,1.1,2.4,2.5 c0,0.8-0.4,1.5-0.8,2C203.9,66.3,200.9,67.7,196.7,67.7z M202.8,51.5c-0.4-4-2.7-7.1-6.9-7.1c-3.8,0-6.5,2.9-7,7.1H202.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.7,64.3c-0.7-0.4-1.2-1.2-1.2-2.2c0-1.4,1.1-2.5,2.5-2.5c0.5,0,1,0.2,1.4,0.4c2.6,1.8,5.4,2.6,7.8,2.6 c2.6,0,4.2-1.2,4.2-2.9v-0.1c0-2.2-2.9-2.8-6.1-3.8c-4-1.2-8.5-2.7-8.5-8v-0.1c0-5.2,4.3-8.3,9.7-8.3c2.9,0,6,0.8,8.6,2.2 c0.9,0.5,1.5,1.3,1.5,2.3c0,1.5-1.2,2.5-2.5,2.5c-0.5,0-0.8-0.1-1.3-0.3c-2.2-1.2-4.5-1.9-6.4-1.9c-2.4,0-3.8,1.2-3.8,2.6v0.1 c0,2.1,2.9,2.8,6.2,3.9c4,1.3,8.5,3,8.5,7.9v0.1c0,5.8-4.4,8.6-10.1,8.6C219.6,67.6,215.8,66.5,212.7,64.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237,32.2c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1v11.7c1.8-2.5,4.3-4.8,8.5-4.8c6.2,0,9.7,4.1,9.7,10.5 v14.6c0,1.8-1.4,3.1-3.1,3.1c-1.8,0-3.1-1.4-3.1-3.1V51.5c0-4.2-2.2-6.6-5.9-6.6c-3.6,0-6.2,2.5-6.2,6.7v12.5 c0,1.8-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1L237,32.2L237,32.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.5627,
    y1: 1001.1274,
    x2: 283.6327,
    y2: 1001.1274,
    gradientTransform: "matrix(1 0 0 1 0 -968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03783D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#2A8C40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3482,
    style: {
      stopColor: "#59A544"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#7EB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#99C748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    style: {
      stopColor: "#A9CF4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD24A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.6,39.2C301.6,39.2,301.7,39.2,301.6,39.2c0.7-1,1.9-0.9,2.8-0.4l0.1,0.1c0.4,0.2,0.9,0.4,1.3,0.6v-0.1 c0.1-0.7,0.1-1.5,0.2-2.2c0.1-0.6,0.3-1.4,1-1.8c0.5-0.3,1-0.3,1.5-0.1c0.1,0,0.1,0,0.2,0.1l0.1,0.1c0.6,0.5,0.7,1.3,0.6,2 c0,0.7,0,1.5,0,2.2s0,1.4,0,2.2c0,1.2-0.5,1.8-0.9,2c-0.3,0.2-0.9,0.5-1.6,0.2c-1.5-0.6-2.8-1.3-4.2-2l-0.1-0.1 c-0.3-0.1-0.5-0.3-0.8-0.4C301,41.1,301.1,40,301.6,39.2z M296.2,28.1c-0.5-0.4-1-0.6-1.7-0.8c-1.6-0.5-3.4-0.2-4.4,1.2 c-0.8,1-1.6,2.5-2.3,3.7c-0.6,1-2.3,3.1-3.6,1.9c-1.2-1.2-0.2-2.9,0.4-4.2c1.2-2.6,3.3-5.9,6.1-7c1.9-0.8,4.1-0.8,6,0.1 c2.2,1.1,4,2.9,5.4,4.9c1.4,2.1,3.2,4.5,3.2,7c0,0.5-0.1,1.1-0.5,1.4c-0.3,0.2-0.7,0.3-1,0.3c-1.3,0-2.2-1-2.7-2.1 C299.7,32.4,298.3,29.6,296.2,28.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.8866,
    y1: 1614.6553,
    x2: 86.8866,
    y2: 1646.4821,
    gradientTransform: "matrix(0.9952 -9.750323e-02 9.750323e-02 0.9952 34.5273 -1562.6366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03783D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#2A8C40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3482,
    style: {
      stopColor: "#59A544"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#7EB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#99C748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    style: {
      stopColor: "#A9CF4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD24A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285,37.3c0,0.7,0.1,1.4,0.1,2.2c0,0.7,0.1,1.3,0.1,2c0.1,1-0.4,2.4-1.6,2.6c-1.6,0.3-2-1.4-2.2-2.5 c0-0.2-0.1-0.6-0.1-0.8c-0.2,0-0.8,0.3-1.5,0.7c-0.2,0.1-0.4,0.3-0.6,0.3c-0.3,0.2-1.4,0.6-2.2-0.3c-0.3-0.4-0.4-0.8-0.4-1.2 c0.1-0.5,0.4-1,0.8-1.3c1.6-1.1,3.1-2.2,4.8-3.2c0.8-0.5,1.4-0.4,1.8-0.2C284.5,35.7,284.9,36.2,285,37.3z M279.9,48.2 c0,0.1-0.1,0.2-0.1,0.4c-0.4,1.5-0.9,2.8-0.9,4.3c0,1.6,0.4,3.3,1.2,4.8c1.4,2.6,3.8,4.8,6.6,5.6c0.9,0.3,1.9,0.5,2.2,1.4 c0.2,0.6-0.1,1.4-0.7,1.8c-0.5,0.4-1.2,0.6-1.9,0.6c-2.3,0.3-4.9-0.4-6.9-1.7s-3.7-3-5-5.1c-1.1-1.8-1.9-3.7-1.9-5.8 c0-2,0.7-3.8,1.7-5.5c1.1-1.9,2.4-3.8,4.1-5.2c1.4-1.1,2.8,0.1,2.6,1.6C280.9,46.2,280.2,47.4,279.9,48.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -13041.7881,
    y1: -13.5685,
    x2: -13031.0664,
    y2: 1.9224,
    gradientTransform: "matrix(-0.9027 -0.4511 0.6247 -1.0428 -11462.1094 -5830.1567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03783D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#2A8C40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3482,
    style: {
      stopColor: "#59A544"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#7EB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#99C748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    style: {
      stopColor: "#A9CF4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD24A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298,61.7c-0.2,1.2-1.1,1.7-2.2,1.8c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0.1-1.5,0.1v0.1c0.3,0.7,0.6,1.4,0.9,2.1 c0.2,0.6,0.4,1.4,0,2.1c-0.3,0.5-0.7,0.7-1.3,0.8c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.2,0c-0.8-0.2-1.2-0.8-1.5-1.4 c-0.3-0.7-0.7-1.3-1-1.9c-0.3-0.6-0.7-1.2-1-1.9c-0.5-1-0.4-1.8-0.2-2.2c0.2-0.4,0.5-0.8,1.3-1c1.6-0.2,3.1-0.3,4.6-0.4h0.1 c0.3,0,0.6,0,0.9,0C297.6,59.8,298.1,60.8,298,61.7L298,61.7z M314.9,53.9c-0.1-1.9-0.8-3.7-1.4-5.5c-0.5-1.3-1.2-2.7-2.3-3.5 c-0.5-0.4-1.1-0.5-1.7-0.1c-0.7,0.4-0.8,1.2-0.7,1.9c0.4,2.2,1.2,4.9,0.6,7.1c-0.7,2.9-2.5,5.8-4.9,7.7 c-1.8,1.4-3.5,2.2-5.8,2.2c-0.7,0-2.2,0.1-2.2,1.1c0,0.5,0.3,0.9,0.7,1.2c1.7,1.4,4.3,1.2,6.3,0.9c3.4-0.6,5.9-1.9,8-4.3 c1.6-1.8,2.8-3.9,3.2-6.4C314.9,55.4,314.9,54.7,314.9,53.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.5295,
    y1: 980.7568,
    x2: 313.5979,
    y2: 980.7568,
    gradientTransform: "matrix(1 0 0 1 0 -968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    style: {
      stopColor: "#91C248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3314,
    style: {
      stopColor: "#5FA844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    style: {
      stopColor: "#379341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7201,
    style: {
      stopColor: "#1A843F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#097B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03783D"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.5,18.6c-0.1,0.9-0.5,1.6-1.2,1.8c-0.2,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.8-0.1-1.2-0.6 c-0.7-0.8-0.7-1.7-0.8-2.3c0-0.1,0-0.3,0-0.4c-0.1-1.3-0.4-2.2-1.1-2.8l0,0c-0.4,0.2-1.1,0.4-1.9,0.1h-0.1 c-1.1-0.6-1.7-1.7-1.4-2.6c0.4-1.4,1.8-1.6,2.3-1.7c1.7-0.2,3.1,0.5,4.1,2.2C294.2,13.9,294.7,16,294.5,18.6z M295.8,19.6 c0.1,0.2,0.2,0.3,0.3,0.4c0.4,0.3,0.5,0,0.8-0.3s0.5-0.6,0.8-0.9c0.5-0.6,1.1-1.1,1.7-1.6l0.2-0.2c1.7-1.4,3.5-2.5,5.8-3.5h0.1 c0.2-0.1,0.9-0.4,0.7-1.1c-0.2-0.6-1-0.4-1.2-0.3l-0.3,0.1c-1.5,0.5-3,1-4.4,2c-1.7,1.1-3,2.5-4.2,4.4c0,0,0,0,0,0.1 C295.7,18.9,295.6,19.3,295.8,19.6z M296.3,16.1c-0.1,0-0.2-0.1-0.3-0.2c-0.4-0.6-0.4-1.3-0.1-1.9c0.3-0.7,0.9-1.4,1.5-1.9 c2.2-2,5.4-2.9,8-4.1c1.2-0.5,2.4-1.1,3.5-1.7c0.7-0.4,1.1-1.5,2-1.4c1.8,0.2,2.7,3.9,2.7,5.3c0,0.3,0,0.5,0,0.8 c-0.1,1.9-0.5,3.7-2,5c-1.7,1.4-3.7,2.2-5.7,2.7c-1.7,0.5-3.2,1-4.9,1.6c-0.7,0.3-1.3,0.2-1.8-0.4c-0.3-0.3-0.8-0.9-0.3-1.3 c0.3-0.3,1-0.5,1.4-0.7c0.5-0.3,1.1-0.5,1.7-0.8c1.5-0.7,3-1.1,4.4-1.9c1.3-0.7,2.5-1.6,3.4-2.6c1.1-1.2,1-2.6,0.8-4 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.8,0.6-1.9,0.9-2.7,1.3c-1,0.4-2,0.8-3,1.2c-1.7,0.6-3.2,1.1-4.8,2c-0.6,0.3-1.2,0.7-1.7,1.2 s-0.9,1-1.4,1.5C296.6,15.9,296.5,16.1,296.3,16.1C296.4,16.1,296.3,16.1,296.3,16.1z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4,96.3L4,96.3c0-4.6,3.3-8.6,8.3-8.6c2.5,0,4.1,0.7,5.7,1.8c0.2,0.2,0.4,0.4,0.4,0.8c0,0.5-0.4,1-0.9,1 c-0.2,0-0.4-0.1-0.6-0.2c-1.2-0.9-2.5-1.5-4.6-1.5c-3.7,0-6.3,3.1-6.3,6.7l0,0c0,3.9,2.5,6.8,6.5,6.8c1.9,0,3.6-0.8,4.8-1.7v-4.1 h-4.5c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.9,0.8-0.9h5.3c0.5,0,0.9,0.4,0.9,1v5.1c0,0.5-0.2,0.9-0.7,1.2c-1.5,1.1-3.5,2.1-6,2.1 C7.2,104.8,4,101,4,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,88.5c0-0.6,0.5-1,1.1-1c0.6,0,1.1,0.4,1.1,1v0.3c0,0.6-0.5,1-1.1,1c-0.6,0-1.1-0.4-1.1-1V88.5z  M23.2,93.1c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v10.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.2,104.7L33.2,104.7c-0.6,0-0.9-0.3-1.2-0.8l-4.6-10.4c0-0.2-0.1-0.3-0.1-0.5c0-0.5,0.4-0.9,0.9-0.9 s0.8,0.3,0.9,0.7l3.9,9.6l4-9.6c0.1-0.4,0.4-0.7,0.9-0.7c0.5,0,0.9,0.4,0.9,0.9c0,0.2,0,0.3-0.1,0.5l-4.6,10.4 C34,104.4,33.7,104.7,33.2,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.8,104.8c-3.3,0-6.1-2.5-6.1-6.4l0,0c0-3.5,2.4-6.4,5.9-6.4c3.6,0,5.7,2.9,5.7,6.2c0,0.5-0.4,0.9-0.9,0.9 h-8.9c0.3,2.6,2.2,4.1,4.3,4.1c1.5,0,2.6-0.6,3.5-1.5c0.1-0.1,0.3-0.2,0.5-0.2c0.5,0,0.8,0.4,0.8,0.8c0,0.2-0.1,0.4-0.3,0.6 C50.2,104,48.9,104.8,46.8,104.8z M50.4,97.7c-0.2-2.2-1.5-4.2-3.9-4.2c-2.2,0-3.7,1.8-4,4.2H50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.2,93.9h-1c-0.5,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h1v-1.1c0-1.4,0.4-2.4,1.1-3.1 c0.6-0.6,1.5-1,2.6-1c0.6,0,1.1,0,1.5,0.1c0.4,0.1,0.7,0.4,0.7,0.8c0,0.5-0.4,0.8-0.9,0.8c-0.3,0-0.7-0.1-1-0.1 c-1.5,0-2.2,0.9-2.2,2.6v1h3.1c0.5,0,0.8,0.3,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8h-3.1v9.8c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9L63.2,93.9L63.2,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.2,98.5L71.2,98.5c0-3.5,2.7-6.5,6.4-6.5c3.7,0,6.4,2.9,6.4,6.4l0,0c0,3.4-2.7,6.4-6.5,6.4 C73.8,104.8,71.2,101.9,71.2,98.5z M82,98.5L82,98.5c0-2.6-2-4.8-4.5-4.8c-2.6,0-4.5,2.2-4.5,4.7l0,0c0,2.6,2,4.8,4.5,4.8 C80.1,103.1,82,101,82,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,98.5L86.4,98.5c0-3.5,2.7-6.5,6.4-6.5c3.7,0,6.4,2.9,6.4,6.4l0,0c0,3.4-2.7,6.4-6.5,6.4 C89.1,104.8,86.4,101.9,86.4,98.5z M97.3,98.5L97.3,98.5c0-2.6-2-4.8-4.5-4.8c-2.6,0-4.5,2.2-4.5,4.7l0,0c0,2.6,2,4.8,4.5,4.8 C95.5,103.1,97.3,101,97.3,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.2,103.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9v-1.7c-1,1.5-2.4,2.7-4.7,2.7c-2.9,0-5.9-2.3-5.9-6.4 l0,0c0-4,2.9-6.4,5.9-6.4c2.2,0,3.7,1.3,4.7,2.6v-6.5c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9V103.7z M102.6,98.4L102.6,98.4 c0,2.9,2.1,4.8,4.3,4.8s4.4-2,4.4-4.7l0,0c0-2.8-2.2-4.7-4.4-4.7C104.6,93.7,102.6,95.4,102.6,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.3,101L123.3,101c0-2.6,2.2-4,5.2-4c1.6,0,2.6,0.2,3.7,0.5v-0.4c0-2.2-1.4-3.3-3.6-3.3 c-1.3,0-2.2,0.3-3.1,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.7,0.5-0.8c1.2-0.5,2.4-0.8,4-0.8 c1.8,0,3,0.5,3.9,1.4c0.8,0.8,1.3,2.1,1.3,3.6v6.6c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9v-1.1c-0.9,1.1-2.2,2.2-4.4,2.2 C125.7,104.8,123.3,103.4,123.3,101z M132.4,100v-1.2c-0.9-0.3-2.2-0.5-3.6-0.5c-2.2,0-3.6,1-3.6,2.5l0,0c0,1.6,1.5,2.4,3,2.4 C130.6,103.3,132.4,102,132.4,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.5,103.2c-0.2-0.1-0.3-0.4-0.3-0.7c0-0.4,0.4-0.8,0.8-0.8c0.2,0,0.3,0,0.5,0.1c1.3,0.9,2.5,1.3,3.9,1.3 c1.5,0,2.5-0.8,2.5-2l0,0c0-1.3-1.5-1.7-3-2.2c-2-0.6-4-1.2-4-3.4l0,0c0-2.2,1.8-3.5,4.2-3.5c1.3,0,2.7,0.4,3.9,1.1 c0.2,0.1,0.5,0.4,0.5,0.8c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.3,0-0.4-0.1c-1.1-0.6-2.2-1-3.2-1c-1.5,0-2.3,0.8-2.3,1.8l0,0 c0,1.2,1.5,1.6,3.1,2.2c1.9,0.6,3.9,1.3,3.9,3.5l0,0c0,2.3-2,3.7-4.4,3.7C147.6,104.7,145.7,104.1,144.5,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.2,104.8c-3.3,0-6.1-2.5-6.1-6.4l0,0c0-3.5,2.4-6.4,5.9-6.4c3.6,0,5.7,2.9,5.7,6.2c0,0.5-0.4,0.9-0.9,0.9 h-8.9c0.3,2.6,2.2,4.1,4.3,4.1c1.5,0,2.6-0.6,3.5-1.5c0.1-0.1,0.3-0.2,0.5-0.2c0.5,0,0.8,0.4,0.8,0.8c0,0.2-0.1,0.4-0.3,0.6 C165.7,104,164.3,104.8,162.2,104.8z M165.9,97.7c-0.2-2.2-1.5-4.2-3.9-4.2c-2.2,0-3.7,1.8-4,4.2H165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.2,98.5L170.2,98.5c0-3.5,2.7-6.5,6.3-6.5c2.1,0,3.4,0.8,4.5,1.8c0.1,0.1,0.3,0.4,0.3,0.7 c0,0.5-0.4,0.9-0.9,0.9c-0.2,0-0.5-0.1-0.6-0.2c-0.9-0.8-1.9-1.5-3.3-1.5c-2.4,0-4.4,2.2-4.4,4.7l0,0c0,2.6,2,4.8,4.5,4.8 c1.4,0,2.5-0.7,3.4-1.5c0.1-0.1,0.3-0.2,0.5-0.2c0.5,0,0.8,0.4,0.8,0.8c0,0.2-0.1,0.4-0.2,0.6c-1.2,1.2-2.5,2-4.6,2 C172.8,104.8,170.2,101.9,170.2,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.7,98.5L183.7,98.5c0-3.5,2.7-6.5,6.4-6.5c3.7,0,6.4,2.9,6.4,6.4l0,0c0,3.4-2.7,6.4-6.5,6.4 C186.3,104.8,183.7,101.9,183.7,98.5z M194.5,98.5L194.5,98.5c0-2.6-2-4.8-4.5-4.8c-2.6,0-4.5,2.2-4.5,4.7l0,0 c0,2.6,2,4.8,4.5,4.8C192.6,103.1,194.5,101,194.5,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.7,93.1c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v1.4c0.8-1.4,2.1-2.3,4.2-2.3c2.9,0,4.7,2,4.7,4.9 v6.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9v-6.4c0-2.2-1.3-3.7-3.4-3.7c-2.2,0-3.7,1.6-3.7,3.8v6.2c0,0.5-0.4,0.9-0.9,0.9 s-0.9-0.4-0.9-0.9L199.7,93.1L199.7,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225,103.7c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-1.7c-1,1.5-2.4,2.7-4.7,2.7 c-2.9,0-5.9-2.3-5.9-6.4l0,0c0-4,2.9-6.4,5.9-6.4c2.2,0,3.7,1.3,4.7,2.6v-6.5c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9V103.7z  M214.4,98.4L214.4,98.4c0,2.9,2.1,4.8,4.3,4.8c2.2,0,4.4-2,4.4-4.7l0,0c0-2.8-2.2-4.7-4.4-4.7C216.4,93.7,214.4,95.4,214.4,98.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.4,98.5L235.4,98.5c0-3.5,2.7-6.5,6.3-6.5c2.1,0,3.4,0.8,4.5,1.8c0.1,0.1,0.3,0.4,0.3,0.7 c0,0.5-0.4,0.9-0.9,0.9c-0.2,0-0.5-0.1-0.6-0.2c-0.9-0.8-1.9-1.5-3.3-1.5c-2.4,0-4.4,2.2-4.4,4.7l0,0c0,2.6,2,4.8,4.5,4.8 c1.4,0,2.5-0.7,3.4-1.5c0.1-0.1,0.3-0.2,0.5-0.2c0.5,0,0.8,0.4,0.8,0.8c0,0.2-0.1,0.4-0.2,0.6c-1.2,1.2-2.5,2-4.6,2 C238.1,104.8,235.4,101.9,235.4,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.6,88c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v6.4c0.8-1.4,2.1-2.3,4.2-2.3c2.9,0,4.7,2,4.7,4.9v6.7 c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-6.4c0-2.2-1.3-3.7-3.4-3.7s-3.7,1.6-3.7,3.8v6.2c0,0.5-0.4,0.9-0.9,0.9 s-0.9-0.4-0.9-0.9V88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.3,101L263.3,101c0-2.6,2.2-4,5.2-4c1.6,0,2.6,0.2,3.7,0.5v-0.4c0-2.2-1.4-3.3-3.6-3.3 c-1.3,0-2.2,0.3-3.1,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.7,0.5-0.8c1.2-0.5,2.4-0.8,4-0.8 c1.8,0,3,0.5,3.9,1.4c0.8,0.8,1.3,2.1,1.3,3.6v6.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-1.1c-0.9,1.1-2.2,2.2-4.4,2.2 C265.6,104.8,263.3,103.4,263.3,101z M272.3,100v-1.2c-0.9-0.3-2.2-0.5-3.6-0.5c-2.2,0-3.6,1-3.6,2.5l0,0c0,1.6,1.5,2.4,3,2.4 C270.5,103.3,272.3,102,272.3,100z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278,93.1c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v1.4c0.8-1.4,2.1-2.3,4.2-2.3c2.9,0,4.7,2,4.7,4.9 v6.7c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-6.4c0-2.2-1.3-3.7-3.4-3.7s-3.7,1.6-3.7,3.8v6.2c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9V93.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.3,98.5L291.3,98.5c0-3.5,2.7-6.5,6.3-6.5c2.1,0,3.4,0.8,4.5,1.8c0.1,0.1,0.3,0.4,0.3,0.7 c0,0.5-0.4,0.9-0.9,0.9c-0.2,0-0.5-0.1-0.6-0.2c-0.9-0.8-1.9-1.5-3.3-1.5c-2.4,0-4.4,2.2-4.4,4.7l0,0c0,2.6,2,4.8,4.5,4.8 c1.4,0,2.5-0.7,3.4-1.5c0.1-0.1,0.3-0.2,0.5-0.2c0.5,0,0.8,0.4,0.8,0.8c0,0.2-0.1,0.4-0.2,0.6c-1.2,1.2-2.5,2-4.6,2 C293.9,104.8,291.3,101.9,291.3,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.5,104.8c-3.3,0-6.1-2.5-6.1-6.4l0,0c0-3.5,2.4-6.4,5.9-6.4c3.6,0,5.7,2.9,5.7,6.2c0,0.5-0.4,0.9-0.9,0.9 h-8.9c0.3,2.6,2.2,4.1,4.3,4.1c1.5,0,2.6-0.6,3.5-1.5c0.1-0.1,0.3-0.2,0.5-0.2c0.5,0,0.8,0.4,0.8,0.8c0,0.2-0.1,0.4-0.3,0.6 C313.9,104,312.6,104.8,310.5,104.8z M314.1,97.7c-0.2-2.2-1.5-4.2-3.9-4.2c-2.2,0-3.7,1.8-4,4.2H314.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodmeshLogoRectangleTagline);
export default __webpack_public_path__ + "static/media/foodmesh_logo_rectangle_tagline.f771a72e.svg";
export { ForwardRef as ReactComponent };